import axios from 'axios'
export default class Payments {
  show = (url) => {
    axios.get(url).then((response) => {
      Modal.show(response.data)
    })
  }
}
